export default __webpack_public_path__ + "static/mxp-icons-d9c001c894fa9ac3c2ba447e5b5b737d.svg";